import {useEffect, useRef} from 'react'

import {useQuantity} from '../quantity/useQuantity'

import {useLoadBalance} from './useLoadBalance'

export const useLoadBalanceAdjustment = () => {
  const loadBalance = useLoadBalance()
  const quantityReturn = useQuantity()
  const volume = quantityReturn.type === 'volume' ? quantityReturn.volume : 0
  const prevVolumeRef = useRef<number | undefined>(undefined)

  const rangeMin = loadBalance.isEnabled ? loadBalance.range.min : undefined
  const rangeMax = loadBalance.isEnabled ? loadBalance.range.max : undefined

  useEffect(() => {
    if (!loadBalance.isEnabled) {
      loadBalance.resetToDefault()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadBalance.isEnabled])

  useEffect(() => {
    if (!loadBalance.isEnabled) {
      prevVolumeRef.current = volume
      return
    }

    const {setMaxLoadSize, maxLoadSize, range} = loadBalance
    const volumeChanged = prevVolumeRef.current !== undefined && prevVolumeRef.current !== volume

    prevVolumeRef.current = volume

    // Volume changed → always reset to halved default; setMaxLoadSize clamps to range.max
    if (volumeChanged) {
      setMaxLoadSize(range.defaultValue)
      return
    }

    // Mount or range change — fix if value is missing or out of range
    if (maxLoadSize === undefined || maxLoadSize < range.min || maxLoadSize > range.max) {
      setMaxLoadSize(range.defaultValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [volume, rangeMin, rangeMax])
}
